<template>
  <div class="error-page container">
    <div class="col-md-8">
      <h3>404 ошибка</h3>
      <p>Неправильно набран адрес, или&nbsp;такой страницы больше не&nbsp;существует.</p>
      <p><router-link to='/'>Вернуться на&nbsp;главную.</router-link></p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'errorPage',
  metaInfo() {
    return {
      title: 'Страница не найдена',
      meta: [{
        name: 'prerender-status-code',
        content: '404',
      }],
    };
  },
};
</script>

<style>
  .error-page{
    padding: 10vh 50px;

    @media (max-width: 600px){
      padding: 10px 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// ErrorPage.vue?e948804c